export default "__VITE_ASSET__qx8jYIaB__"